import { render } from "./teaAgeEchart.vue?vue&type=template&id=90d1cf9a&scoped=true"
import script from "./teaAgeEchart.vue?vue&type=script&lang=js"
export * from "./teaAgeEchart.vue?vue&type=script&lang=js"

import "./teaAgeEchart.vue?vue&type=style&index=0&id=90d1cf9a&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d1cf9a"]])

export default __exports__